/* eslint-disable react-hooks/exhaustive-deps */
import { Divider, Row } from 'antd'
import { UsersAdmin } from 'src/core/models'
import { useTranslation } from 'next-i18next'
import React, { useEffect, useState } from 'react'
import { usersAdminListColumns } from 'src/core/table-columns'
import { getFilteredUsers, showNotification } from 'src/core/helpers'
import { useAppDispatch, useAppSelector, useWindowSize } from 'src/app/hooks'
import AdminUsersListHeader from './AdminUsersListHeader/AdminUsersListHeader'
import { CustomSeo, PageTitle, GoBackLink, CustomCard, CustomTable, CustomCol } from 'src/components'
import {
  userAdminListFilterSelector,
  resetValidateUserState,
  validateUserSelector,
  usersAdminSelector,
} from 'src/features'

const ValidateUsersPageContent: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const { width } = useWindowSize()
  const isMobile = width <= 800
  const { loading, data: bigUsersList } = useAppSelector(usersAdminSelector)
  const filters = useAppSelector(userAdminListFilterSelector)
  const [filteredUsers, setFilteredUsers] = useState<UsersAdmin[]>(bigUsersList)
  const {
    success: successValidation,
    error: errorValidation
  } = useAppSelector(validateUserSelector)

  /* Manage List Data */
  useEffect(() => {
    const newUsers = getFilteredUsers(filters, bigUsersList)
    setFilteredUsers(newUsers)
  }, [filters])

  /* Validate Features */
  useEffect(() => {
    if (successValidation) {
      showNotification('success', t('Validate.Success'))
      dispatch(resetValidateUserState())
    }
  }, [successValidation])

  useEffect(() => {
    if (errorValidation) {
      showNotification('warning', t('Validate.Error'))
      dispatch(resetValidateUserState())
    }
  }, [errorValidation])
  /* Validate Features Ends Here ...*/

  return <>
    {/* Seo */}
    <CustomSeo title={t('My ClimateTrade: Validate Users')} />

    {/* Page Header */}
    <Row>
      <CustomCol>
        <GoBackLink link={'/admin'} label={t('Validate.GoBack')} />
      </CustomCol>
      <CustomCol>
        <div className={isMobile ? 'centered-div' : 'float-right'}>
          <PageTitle>{t('Validate.Title')}</PageTitle>
        </div>
      </CustomCol>
    </Row>

    {/* Users List */}
    <CustomCard loading={loading}>
      <AdminUsersListHeader usersLength={filteredUsers.length} />
      <Divider />
      <CustomTable
        columns={usersAdminListColumns}
        dataSource={filteredUsers}
        rowClassName={() => 'fade-animation'}
        pageSize={10}
      />
    </CustomCard>
  </>
}

export default ValidateUsersPageContent
